import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { SyncOperation, SyncOperationResult } from "../components/Common/dtos/PendingTransportSyncDto";

const useCommitTransportSync = (siteId: string, options?: RequestOptions<SyncOperationResult[]>) => {
  const business = useSelectedBusiness();
  return useUserRequest<SyncOperation[], SyncOperationResult[]>({
    path: `/api/businesses/${business.id}/transports/sync/commit?siteId=${siteId}`,
    method: HttpMethod.POST,
  }, options);
}

export default useCommitTransportSync;
